module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gg-b8779f1806c259de289ac4b3919fd732.svg";